import { render, staticRenderFns } from "./AuctionImpugnations.vue?vue&type=template&id=69115895&scoped=true&"
import script from "./AuctionImpugnations.vue?vue&type=script&lang=js&"
export * from "./AuctionImpugnations.vue?vue&type=script&lang=js&"
import style0 from "./AuctionImpugnations.vue?vue&type=style&index=0&id=69115895&lang=scss&scoped=true&"
import style1 from "@/styles/manifestacao.scss?vue&type=style&index=1&id=69115895&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69115895",
  null
  
)

export default component.exports